export const TYPOGRAPHY_HEADLINE1 = 'typography__h1',
  TYPOGRAPHY_HEADLINE2 = 'typography__h2',
  TYPOGRAPHY_HEADLINE3 = 'typography__h3',
  TYPOGRAPHY_HEADLINE4 = 'typography__h4',
  TYPOGRAPHY_BODY_MEDIUM = 'typography__body-medium',
  TYPOGRAPHY_BODY_REGULAR = 'typography__body-regular',
  TYPOGRAPHY_BODY_LIGHT = 'typography__body-light',
  TYPOGRAPHY_BODY_REGULAR_LIGHT = 'typography__body-regular-light',
  TYPOGRAPHY_HYPERLINK = 'typography__hyperlink',
  TYPOGRAPHY_BODY_PARAGRAPH = 'typography__body-paragraph',
  TYPOGRAPHY_ICON_LABEL = 'typography-icon-label';
